<template>
  <GoogleLogin v-if="!logged_in" id="notLoggedIn" :callback="callback"></GoogleLogin>
  <div v-if="logged_in" id="loggedIn">{{ $store.getters['getUIText']('loggedinas') }} {{name}}. <button @click="logout">{{ $store.getters['getUIText']('logout') }}</button></div>
</template>

<script>
import { decodeCredential } from 'vue3-google-login';
import API from "../assets/js/api";
export default {
  name: "login",
  data(){
    return {
      logged_in: false,
      credential: null,
      name: null
    }
  },
  methods: {
    callback(data){
      // this.credential = decodeCredential(response.credential);
      // console.log(decodeCredential(response.credential));
      // console.log(Date.now());
      // this.logged_in = true;
      const decoded = decodeCredential(data.credential)
      console.log(decoded);
      this.$store.commit("user/setName", { firstName: decoded.given_name, lastName: decoded.family_name });
      this.$store.commit("user/setUserId", decoded.email);
      API.registerUser(this.$store.getters["user/user_id"], this.$store.getters["user/first_name"], this.$store.getters["user/last_name"])
          .then(response=>{console.log(response)});
      this.name = this.$store.getters["user/full_name"];
      this.logged_in = true;
    },
    logout(){
      // googleLogout();
      this.logged_in = false;
      this.$store.dispatch("user/deleteUser");
    }
  },
  mounted(){
    // this.login();
    // googleSdkLoaded((google)=>{
    //   google.accounts.oauth2.initCodeClient({
    //     client_id: '781905110527-s2rjnapqnlo6hact2j793akl6ln0alvr.apps.googleusercontent.com',
    //     scope: 'email',
    //     callback: (response) => {
    //       console.log("Handle the response", response)
    //     }
    //   }).requestCode();
    // })
    this.name = this.$store.getters["user/full_name"];
    this.logged_in = this.$store.getters["user/user_id"] !== -1;
  }
}
</script>

<style scoped lang="less">
  #loggedIn{
    font-size: 1.2rem;
    line-height: 45px;
    text-align: right;
  }
</style>
